export const navItems = [
  { label: 'O Meni', href: '/o-meni' },
  { label: 'Usluge', href: '/usluge' },
  { label: 'Rezultati', href: '/rezultati' },
  { label: 'Pitanja i Iskustva', href: '/pitanja' },
  { label: 'Kontakt', href: '/kontakt' }
];